import { useContext } from "react";
import "./index.css";
import { AppContext } from "../../context/AppContext";
import RequestCallButton from "../CallReqButton";

const testimonialsData = [
  {
    rating: "5.0",
    text: `"IBIX Qodify's Full Stack program transformed my career completely. From a non-tech background to landing a role at TCS with ₹8 LPA — the journey has been incredible!"`,
    tags: ["Full Stack Development", "₹8 LPA"],
    name: "Lakshmi Priya",
    role: "Software Engineer",
    logo: "https://iqteche.in/static/media/wl_client_images/a2fbb213c85744c3a3d73c2f0b6e2f05.png",
    logoClass: "story-card-company-logo",
  },
  {
    rating: "5.0",
    text: `"The Data Science program at IBIX Qodify is exceptional. The hands-on projects and mentorship helped me secure a Data Scientist role at Infosys!"`,
    tags: ["Data Science", "₹11 LPA"],
    name: "Muni Prasad",
    role: "Data Scientist",
    logo: "https://iqteche.in/static/media/wl_client_images/c56b7ebf6a4d439493b686aa123a1f10.png",
    logoClass: "big-company-logo",
  },
  {
    rating: "5.0",
    text: `"The Cloud & DevOps program prepared me for real-world challenges. The AWS certification and practical projects made all the difference in my interview at Wipro!"`,
    tags: ["Cloud & DevOps", "₹10 LPA"],
    name: "Sri Sravani",
    role: "DevOps Engineer",
    logo: "https://iqteche.in/static/media/wl_client_images/772917b40b8d43d3bda04ed0463a006a.png",
    logoClass: "story-card-company-logo",
  },
  {
    rating: "4.8",
    text: `"From a mechanical engineer to a Full Stack Developer at Accenture - IBIX Qodify made this career transition smooth and successful. Highly recommend their programs!"`,
    tags: ["Full Stack Development", "₹9 LPA"],
    name: "Vikash Gupta",
    role: "Full Stack Developer",
    logo: "https://iqteche.in/static/media/wl_client_images/c843eccade7a46889062b6a4864eb1d9.png",
    logoClass: "big-company-logo",
  },
  {
    rating: "4.8",
    text: `"Support at IBIX Qodify is outstanding. They prepared me thoroughly for interviews and I got placed in HCL after course completion!"`,
    tags: ["Full Stack Development", "₹8 LPA"],
    name: "Divya Chandra",
    role: "Full Stack Developmer",
    logo: "https://iqteche.in/static/media/wl_client_images/4e31341c5f874122814b2b95f1b3c3d7.png",
    logoClass: "story-card-company-logo",
  },
  {
    rating: "5.0",
    text: `"The industry-relevant curriculum and expert mentors at IBIX Qodify helped me master cloud technologies and land my dream job at Capgemini as a Cloud Engineer!"`,
    tags: ["Cloud & DevOps", "₹10 LPA"],
    name: "Venkatesh Naidu",
    role: "Cloud Engineer",
    logo: "https://iqteche.in/static/media/wl_client_images/bf5e98a5ebbd4ff4aa215c29d80fe7d3.png",
    logoClass: "story-card-company-logo",
  },
];

const SuccessStories = () => {
  const { successStoriesRef } = useContext(AppContext);
  return (
    <section
      id="success-stories"
      className="success-stories-container"
      ref={successStoriesRef}
    >
      <div className="container ">
        <h1 className="success-stories-heading text-center">
          Success Stories from Our <br />
          <span>Amazing Students</span>
        </h1>
        <div className="row">
          {testimonialsData.map((item, index) => {
            const { rating, text, tags, name, role, logo, logoClass } = item;

            return (
              <div
                className="col-12 col-md-6 col-lg-4"
                key={`testimonial-col-${index}`}
                id={`testimonial-col-${index}`}
              >
                <div
                  className="testimonial-card"
                  id={`testimonial-card-${index}`}
                >
                  <div className="stars" id={`stars-${index}`}>
                    ⭐ <span>{rating}</span>
                  </div>

                  <p
                    className="testimonial-text"
                    id={`testimonial-text-${index}`}
                  >
                    <em>{text}</em>
                  </p>

                  <div className="tags" id={`tags-${index}`}>
                    <span className="tag tag-blue" id={`tag-blue-${index}`}>
                      {tags[0]}
                    </span>
                    <span className="tag tag-green" id={`tag-green-${index}`}>
                      {tags[1]}
                    </span>
                  </div>

                  <div className="user-info" id={`user-info-${index}`}>
                    <div>
                      <h4 id={`name-${index}`}>{name}</h4>
                      <p id={`role-${index}`}>{role}</p>
                    </div>
                    <img
                      src={logo}
                      alt={`${name} - ${role}`}
                      className={logoClass}
                      id={`logo-${index}`}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <h4 className="text-center">and many more...</h4>
      </div>
      <RequestCallButton />
    </section>
  );
};

export default SuccessStories;
